import { AuthStatus, useAuth, useDocumentQuery } from '@lessonup/client-integration';
import { MyRegisteredUser } from '../../features/TeacherTopBar/TeacherTopBar.graphql';
import { MyRegisteredUserDocument } from '../../features/TeacherTopBar/TeacherTopBar.graphql.generated';

export const useMyRegisteredUser = (): MyRegisteredUser | undefined => {
  const auth = useAuth();

  const { data } = useDocumentQuery(MyRegisteredUserDocument, {
    fetchPolicy: 'cache-first',
    skip: auth.type !== AuthStatus.LOGGED_IN, // Don't query if we aren't logged in
  });
  return data?.viewer;
};

// TODO - should only rerender when userId changes, now tiggers on any user change
export const useMyRegisteredUserId = (): string | undefined => {
  const user = useMyRegisteredUser();
  return user?.id;
};
